import { Middleware } from "@reduxjs/toolkit";

import { saveToStorage } from "../../common/utils/functions/localStorage";

export const cityCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type?.startsWith?.("city/")) {
      const city = store.getState().city.city;
      try {
        saveToStorage("city", city);
      } catch {
        // ignore
      }
    }

    return result;
  };
